import { __rest, __assign } from '../_virtual/_tslib.js';
import React from 'react';
import { Svg } from './style.js';

function SVGWrapper(_a) {
    var width = _a.width, height = _a.height, _b = _a.ratio, ratio = _b === void 0 ? { x: 1, y: 1 } : _b, children = _a.children, onClick = _a.onClick, style = _a.style, props = __rest(_a, ["width", "height", "ratio", "children", "onClick", "style"]);
    return (React.createElement(Svg, __assign({ width: width, height: height, viewBox: "0 0 " + width + " " + height, fill: "none", xmlns: "http://www.w3.org/2000/svg", onClick: onClick, style: style }, props),
        React.createElement("g", { transform: "scale(" + ratio.x.toFixed(1) + ", " + ratio.y.toFixed(1) + ")" }, children)));
}

export { SVGWrapper as default };
